import { getBackgroundCSS, getSpaceCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { verticalAlign, textAlign, bgOverlay, minHeight, padding } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#vbbVideoBG-${clientId}{
			min-height: ${minHeight};
		}
		#vbbVideoBG-${clientId} .vbbVideoContent{
			justify-content: ${verticalAlign};
			text-align: ${textAlign};
			min-height: ${minHeight};
			padding: ${getSpaceCSS(padding)};
		}
		#vbbVideoBG-${clientId} .vbbVideoOverlay{
			${getBackgroundCSS(bgOverlay)}
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;